import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMentorAuth } from '../contexts/MentorAuthContext';

export default function ProtectedMentorRoute({ children }) {
  const { isAuthenticated, isLoading } = useMentorAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white">Cargando...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/mentor/login" replace />;
  }

  return children;
}
